import axios from 'axios'

const { REACT_APP_UNLEASH_URL, REACT_APP_UNLEASH_CLIENT_KEY, REACT_APP_API_ENV } = process.env

const APP_NAME = 'fe-user-dashboard'
const TIMEOUT_MS = 3000
const CACHE_MS = 60 * 1000

export const FEATURE_FLAGS = {
  privateS3Documents: 'use-private-s3-documents'
}

const cache = {}

/**
 * Reads a flag from the Unleash Frontend API. Any failure (missing key,
 * timeout, Unleash down) returns false, which keeps the current behavior.
 * @param {string} name FEATURE_FLAGS
 * @param {{ userId?: string }} [context]
 * @returns {Promise<boolean>}
 */
export const isFeatureEnabled = async (name, context = {}) => {
  if (!REACT_APP_UNLEASH_URL || !REACT_APP_UNLEASH_CLIENT_KEY) return false

  const cacheKey = JSON.stringify(context)
  const cached = cache[cacheKey]

  try {
    if (!cached || Date.now() - cached.at > CACHE_MS) {
      const { data } = await axios.get(REACT_APP_UNLEASH_URL, {
        // Staging and production share the Unleash environment; the flags are
        // scoped by the appEnv constraint.
        params: { appName: APP_NAME, 'properties[appEnv]': REACT_APP_API_ENV, ...context },
        headers: { Authorization: REACT_APP_UNLEASH_CLIENT_KEY },
        timeout: TIMEOUT_MS
      })
      cache[cacheKey] = { at: Date.now(), toggles: (data && data.toggles) || [] }
    }

    return cache[cacheKey].toggles.some(toggle => toggle.name === name && toggle.enabled)
  } catch (err) {
    return false
  }
}
